import {createRef, useEffect, useState} from "react";
import {AuthRedirectAdmins, PostJSON, PostUploadJSON, ServerImage} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {BreadCrumbs} from "../../../components/open/pages";
import {Link, useParams} from "react-router-dom";
import {
    CheckIcon,
    ThinAddIcon,
    ThinAddPersonIcon,
    ThinCameraIcon,
    ThinCloseIcon,
    ThinCreditScoreIcon,
    ThinEditIcon,
    ThinInfoIcon,
    ThinnerPeopleIcon,
    ThinSpecialIcon,
    ThinTimeIcon, ThinTrashIcon,
    TomansIcon
} from "../../../components/icons/material-icons";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {AdminsAddEditCenterClassModal} from "./add-edit-center-class";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {AdminsCenterApproveStudentModal} from "./approve-modal";
import {RemoveModal} from "../../../components/template/remove-modal";
import {AdminsSpecialStudentPickerModal} from "./special-student-picker";
import {AdminsChooseStudentsForSciClassModal} from "./choose-students";
import {ConfirmModal} from "../../../components/template/confirm-modal";

interface classStudentsInterface {
    id: number,
    studentId: number,
    name: string,
    price: number,
    approvedAt: string,
    isPaid: 0 | 1,
    paidAt: string,
    isManual:0|1,
}

interface classStudentsPending {
    id: number,
    studentId: number,
    name: string,
    createdAt: string,
}

interface specialsInterface {
    specialId: number,
    studentId: number,
    name: string,
    class: string, // school class
}

export const AdminsCenterClassDetailsScreen = () => {
    const {classId} = useParams();
    const [data, setData] = useState({
        loaded: false,
        students: [] as classStudentsInterface[],
        pending: [] as classStudentsPending[],
        title: '',
        desc: '',
        img: '',
        max: 1,
        teacher: '',
        price: 0,
        createdAt: '2000-01-01 00:00:00',
        isHidden: false,
        isWorkshop: false,
        hasExpiration: false,
        expiresAt: '2000-01-01 00:00:00',
        sessionCount: 0,
        presentedAt: '2000-01-01 00:00:00',
        classesAllowed: [] as { title: string, id: number }[],
        specials: [] as specialsInterface[],
        classesAllowedInt: [] as number[],
        specialIds: [] as number[],
        canSetPaid:false,
    });
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/admins/center/class/get',
            {
                id: classId,
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                students: classStudentsInterface[] | null,
                pending: classStudentsPending[] | null,
                title: string,
                desc: string,
                img: string,
                max: number,
                teacher: string,
                price: number, // suggested
                createdAt: string,
                isHidden: 0 | 1,
                isWorkshop: 0 | 1,
                allowedClasses: { title: string, id: number }[] | null,
                hasExpiration: 0 | 1,
                expiresAt: string,
                sessionCount: number,
                presentedAt: string,
                specials: specialsInterface[] | null,
                canPay:boolean,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                let lst: number[] = [];
                if (d.allowedClasses !== null)
                    d.allowedClasses.forEach(e => {
                        lst.push(e.id);
                    });
                let lst2: number[] = [];
                if (d.specials !== null)
                    d.specials.forEach(e => {
                        lst2.push(e.studentId);
                    });
                document.title = d.title + " | مرکزعلمی | اتوماسیون شهاب";
                setData({
                    canSetPaid: d.canPay,
                    loaded: true,
                    students: d.students === null ? [] : d.students,
                    pending: d.pending === null ? [] : d.pending,
                    title: d.title,
                    desc: d.desc,
                    img: d.img,
                    max: d.max,
                    teacher: d.teacher,
                    price: d.price,
                    createdAt: d.createdAt,
                    isHidden: d.isHidden === 1,
                    isWorkshop: d.isWorkshop === 1,
                    specials: d.specials === null ? [] : d.specials,
                    classesAllowed: d.allowedClasses === null ? [] : d.allowedClasses,
                    expiresAt: d.expiresAt,
                    hasExpiration: d.hasExpiration === 1,
                    sessionCount: d.sessionCount,
                    presentedAt: d.presentedAt,
                    classesAllowedInt: lst,
                    specialIds: lst2,
                });
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        // document.title = "کلاس مرکزعلمی | اتوماسیون شهاب";
        fetchData();
    }, []);
    const [tab, setTab] = useState('info' as 'info' | 'students' | 'signup' | 'specials');
    const [addEdit, setAddEdit] = useState(false);
    const [approveModal, setApproveModal] = useState({
        show: false,
        pendingId: 0,
        name: '',
    });
    const imgRef = createRef<any>();
    const onPhotoSelected = () => {
        const c = imgRef.current as HTMLInputElement;
        const x = c.files;
        if (x === null || x!.length !== 1) {
            c.value = '';
            return;
        }
        const fileSize = x[0].size / 1048576;
        const ext = x[0].name.split('.')[x[0].name.split.length - 1].toLowerCase();
        if (fileSize > 10) {
            c.value = '';
            ShowSnackbar(
                'اندازه حجم تصویر باید کمتر از ۱۰ مگابایت باشد.',
                'باشه',
                5000,
            );
            return;
        }
        if (ext !== 'jpg' && ext !== 'png' && ext !== 'jpeg') {
            c.value = '';
            ShowSnackbar(
                'پسوند فایل تصویر باید JPG یا PNG باشد.',
                'باشه',
                5000,
            );
            return;
        }
        ShowProgressLoading();
        PostUploadJSON(
            Apis.server + '/core/admins/center/class/edit-img',
            {
                id: classId as string,
                img: x![0],
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                photo: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    'تصویر جدید برای کلاس ذخیره شد.',
                    'باشه',
                    5000,
                );
                fetchData();
                window.scrollTo({top: 0, behavior: 'smooth'});
            },
            () => {
                HideProgressLoading();
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const openPhotoPicker = () => {
        (imgRef.current as HTMLInputElement).click();
    };
    const [pickSpecialStudent, setPickSpecialStudent] = useState(false);
    const [removeSpecialStudent, setRemoveSpecialStudent] = useState({
        show: false,
        id: 0,
        name: '',
    });
    const [manuallyAddStudents, setManuallyAddStudents] = useState(false);
    const [markAsPaid, setMarkAsPaid] = useState({
        show: false,
        recordId: 0,
        name: '',
    });
    const [removeStudents,setRemoveStudents] = useState({
        show:false,
        studentId:0,
        name:'',
    });
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'مرکز علمی', url: '/admins/center'},
                {title: 'کلاس ' + data.title, url: '/admins/center'},
            ]}/>
            <div className="container" data-aos={"fade-up"} data-aos-duration={1000}>
                <div className="row">
                    <div className="col-lg-4">
                        <div className="d-none d-lg-block" style={{height: 60}}/>
                        <div className="student-profile">
                            <button className={"student-profile-picker open-tooltip"} onClick={openPhotoPicker}>
                                <ThinCameraIcon/>
                                <i>تصویر جدید</i>
                            </button>
                            <i style={{
                                backgroundImage: `url(${ServerImage(data.img, 500, 0)})`,
                                width: '100%',
                                borderRadius: 10
                            }}/>
                            <b>{data.title}</b>
                            <span>{CurrencyFormat(data.students.length)} دانش‌آموز</span>
                            <em data-color={!data.isHidden ? 'blue' : 'red'}>
                                {data.isHidden ? 'پنهان' : 'نمایان و فعال'}
                            </em>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="open-tabbar" style={{marginTop: 20}}>
                            <div className="open-tabbar-inner">
                                <button onClick={() => {
                                    setTab('info');
                                    window.scrollTo({top: 0, behavior: 'smooth'});
                                }} className={tab === 'info' ? 'active' : ''}>
                                    <ThinInfoIcon/>
                                    مشخصات
                                </button>
                                <button onClick={() => {
                                    setTab('specials');
                                    window.scrollTo({top: 0, behavior: 'smooth'});
                                }} className={tab === 'specials' ? 'active' : ''}>
                                    <ThinSpecialIcon/>
                                    متمایزها
                                </button>
                                <button onClick={() => {
                                    setTab('students');
                                    window.scrollTo({top: 0, behavior: 'smooth'});
                                }} className={tab === 'students' ? 'active' : ''}>
                                    <ThinnerPeopleIcon/>
                                    دانش‌آموزان
                                </button>
                                <button onClick={() => {
                                    setTab('signup');
                                    window.scrollTo({top: 0, behavior: 'smooth'});
                                }} className={tab === 'signup' ? 'active' : ''}>
                                    <ThinTimeIcon/>
                                    ثبت‌نام ها
                                </button>
                            </div>
                        </div>
                        {
                            tab === 'info' ?
                                <div className="screen-card">
                                    <div className="screen-card-header">
                                        <b>مشخصات کلاس</b>
                                        <div className="d-flex align-items-center" style={{gap: 10}}>
                                            <button onClick={() => setAddEdit(true)}>
                                                <ThinEditIcon/>
                                                <span>ویرایش</span>
                                            </button>
                                            <button onClick={openPhotoPicker}>
                                                <ThinCameraIcon/>
                                                <span>آپلود تصویر</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="student-info">
                                        <span>عنوان کلاس:</span>
                                        <b>{data.title}</b>
                                        <span>نوع:</span>
                                        <b>{data.isWorkshop ? 'کارگاه' : 'کلاس عادی'}</b>
                                        <span>مربی:</span>
                                        <b>{data.teacher}</b>
                                        <span>قیمت پیشنهادی:</span>
                                        <b>{CurrencyFormat(data.price)} تومان</b>
                                        <span>ظرفیت کلاس:</span>
                                        <b>{CurrencyFormat(data.max)} نفر</b>
                                        <span>دانش‌آموزان تایید شده:</span>
                                        <b>{CurrencyFormat(data.students.length)} نفر</b>
                                        <span>دانش‌آموزان در انتظار تایید:</span>
                                        <b>{CurrencyFormat(data.pending.length)} نفر</b>
                                        <span>کلاس های هدف:</span>
                                        <b>
                                            {
                                                data.classesAllowed.map((c, i) =>
                                                    <strong key={"KwwWi342947s4" + i}>
                                                        {c.title}
                                                    </strong>
                                                )
                                            }
                                        </b>
                                        {
                                            data.hasExpiration ?
                                                <>
                                                    <span>تاریخ پایان ثبت‌نام:</span>
                                                    <b>{StringDigitsConvertToPersian(data.expiresAt.split(' ')[1] + " " + GregorianToPersian(data.expiresAt.split(' ')[0]).replaceAll('-', '/'))}</b>
                                                </> : null
                                        }
                                        {
                                            !data.isWorkshop ?
                                                <>
                                                    <span>تعداد جلسات:</span>
                                                    <b>{CurrencyFormat(data.sessionCount)} جلسه</b>
                                                </> : null
                                        }
                                        {
                                            data.isWorkshop ?
                                                <>
                                                    <span>تاریخ برگزاری:</span>
                                                    <b>{StringDigitsConvertToPersian(`${data.presentedAt.split(' ')[1].split(':')[0]}:${data.presentedAt.split(' ')[1].split(':')[1]}` + " " + GregorianToPersian(data.presentedAt.split(' ')[0]).replaceAll('-', '/'))}</b>
                                                </> : null
                                        }
                                        <span>توضیحات:</span>
                                        <b style={{
                                            lineHeight: '40px',
                                            textAlign: 'justify',
                                            marginBottom: 0
                                        }}>{data.desc}</b>
                                    </div>
                                </div> :
                                (
                                    tab === 'students' ?
                                        <div className={"screen-card"}>
                                            <div className="screen-card-header">
                                                <b>دانش آموزان تایید شده</b>
                                                <button onClick={() => setManuallyAddStudents(true)}>
                                                    <ThinAddPersonIcon/>
                                                    <span>افزودن دستی</span>
                                                </button>
                                            </div>
                                            <table
                                                className="table open-table table-striped table-hover table-bordered">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>دانش‌آموز</th>
                                                    <th>هزینه</th>
                                                    {/*<th>زمان تایید</th>*/}
                                                    <th>پرداخت</th>
                                                    <th>تاریخ پرداخت</th>
                                                    <th>روش پرداخت</th>
                                                    <th>امکانات</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    data.students.map((s, i) =>
                                                        <tr key={"KwWw2OsSs1pp0" + i}>
                                                            <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                                            <td>
                                                                <Link to={`/admins/students/view/${s.studentId}`}>
                                                                    {s.name}
                                                                </Link>
                                                            </td>
                                                            <td>
                                                                <span>{CurrencyFormat(s.price)}<TomansIcon/></span>
                                                            </td>
                                                            {/*<td>{StringDigitsConvertToPersian(s.approvedAt.split(' ')[1] + " " + GregorianToPersian(s.approvedAt.split(' ')[0]).replaceAll('-', '/'))}</td>*/}
                                                            <td>
                                                                {
                                                                    s.isPaid === 1 ?
                                                                        <em>
                                                                            <CheckIcon/>
                                                                            پرداخت شده
                                                                        </em> :
                                                                        <em data-color={"red"}>
                                                                            <ThinTimeIcon/>
                                                                            در انتظار
                                                                        </em>
                                                                }
                                                            </td>
                                                            <td>
                                                                {
                                                                    s.isPaid ?
                                                                        (StringDigitsConvertToPersian(s.paidAt.split(' ')[1] + " " + GregorianToPersian(s.paidAt.split(' ')[0]).replaceAll('-', '/')))
                                                                        : '-'
                                                                }
                                                            </td>
                                                            <td>
                                                                {s.isPaid ? (s.isManual ? 'دستی' : 'آنلاین') : '-'}
                                                            </td>
                                                            <td>
                                                                <div className="d-inline-flex justify-content-center align-items-center" style={{gap:5}}>
                                                                    {
                                                                        data.canSetPaid ?
                                                                            (s.isPaid ? null :
                                                                                <button className={"open-tooltip"}
                                                                                        onClick={() => setMarkAsPaid({
                                                                                            show: true,
                                                                                            name: s.name,
                                                                                            recordId: s.id,
                                                                                        })}>
                                                                                    <ThinCreditScoreIcon/>
                                                                                    <i>پرداخت دستی</i>
                                                                                </button>) : null
                                                                    }
                                                                    <button className="open-tooltip" onClick={()=>setRemoveStudents({
                                                                        show: true,
                                                                        name: s.name,
                                                                        studentId: s.studentId,
                                                                    })}>
                                                                        <i>حذف</i>
                                                                        <ThinTrashIcon/>
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                                </tbody>
                                            </table>
                                        </div> :
                                        (tab === 'signup' ? <div className={"screen-card"}>
                                                <div className="screen-card-header">
                                                    <b>دانش آموزان درانتظار تایید</b>
                                                </div>
                                                <table
                                                    className="table open-table table-striped table-hover table-bordered">
                                                    <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>دانش‌آموز</th>
                                                        <th>زمان ثبت‌نام</th>
                                                        <th>امکانات</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        data.pending.map((s, i) =>
                                                            <tr key={"KwWw2OsSs1pp02" + i}>
                                                                <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                                                <td>
                                                                    <Link to={`/admins/students/view/${s.studentId}`}>
                                                                        {s.name}
                                                                    </Link>
                                                                </td>
                                                                <td>{StringDigitsConvertToPersian(s.createdAt.split(' ')[1] + " " + GregorianToPersian(s.createdAt.split(' ')[0]).replaceAll('-', '/'))}</td>
                                                                <td>
                                                                    <button className="open-tooltip" onClick={() => {
                                                                        const d = data.max;
                                                                        const f = data.students.length;
                                                                        if ((f + 1) > d) {
                                                                            ShowSnackbar(
                                                                                'ظرفیت کلاس تکمیل است.',
                                                                                'باشه',
                                                                                5000,
                                                                            );
                                                                            return;
                                                                        }
                                                                        setApproveModal({
                                                                            show: true,
                                                                            name: s.name,
                                                                            pendingId: s.id,
                                                                        });
                                                                    }}>
                                                                        <CheckIcon/>
                                                                        <i>تایید کردن</i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                    </tbody>
                                                </table>
                                            </div> :
                                            <div className={"screen-card"}>
                                                <div className="screen-card-header">
                                                    <b>دانش آموزان متمایز</b>
                                                    <button onClick={() => setPickSpecialStudent(true)}>
                                                        <ThinAddIcon/>
                                                        <span>افزودن</span>
                                                    </button>
                                                </div>
                                                <table
                                                    className="table open-table table-striped table-hover table-bordered">
                                                    <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>دانش‌آموز</th>
                                                        <th>کلاس مدرسه</th>
                                                        <th>امکانات</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        data.specials.map((s, i) =>
                                                            <tr key={"KPWw21OsSs1pp2202" + i}>
                                                                <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                                                <td>
                                                                    <Link to={`/admins/students/view/${s.studentId}`}>
                                                                        {s.name}
                                                                    </Link>
                                                                </td>
                                                                <td>
                                                                    {s.class}
                                                                </td>
                                                                <td>
                                                                    <button onClick={() => setRemoveSpecialStudent({
                                                                        show: true,
                                                                        id: s.studentId,
                                                                        name: s.name,
                                                                    })} className={"open-tooltip"}>
                                                                        <ThinCloseIcon/>
                                                                        <i>عدم تمایز</i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>)
                                )
                        }
                    </div>
                </div>
            </div>
            <input
                style={{display: 'none'}}
                type="file"
                ref={imgRef}
                onChange={onPhotoSelected}
                accept={".png,.jpg,.jpeg"}
            />
            <AdminsAddEditCenterClassModal
                active={addEdit}
                closeHandler={() => setAddEdit(false)}
                isEdit={true}
                id={parseInt(classId as string)}
                title={data.title}
                desc={data.desc}
                teacher={data.teacher}
                price={data.price}
                onDone={() => {
                    ShowProgressLoading();
                    window.scrollTo({top: 0, behavior: 'smooth'});
                    fetchData();
                }}
                maxParticipants={data.max}
                allowedClasses={data.classesAllowedInt}
                isWorkshop={data.isWorkshop}
                hasExpiration={data.hasExpiration}
                expiresAt={data.expiresAt}
                sessionCount={data.sessionCount}
                presentedAt={data.presentedAt}
            />
            <AdminsCenterApproveStudentModal
                active={approveModal.show}
                closeHandler={() => setApproveModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                pendingId={approveModal.pendingId}
                name={approveModal.name}
                suggestedPrice={data.price}
                onDone={() => {
                    ShowProgressLoading();
                    window.scrollTo({top: 0, behavior: 'smooth'});
                    fetchData();
                }}
            />
            <RemoveModal
                active={removeSpecialStudent.show}
                closeHandler={() => setRemoveSpecialStudent(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"عدم تمایز دانش‌آموز"}
                desc={"آیا مطمئن هستید می‌خواهید " + removeSpecialStudent.name + " را از لیست دانش‌آموزان مجاز به شرکت در این کلاس حذف کنید؟"}
                onRemove={() => {
                    const x = {...removeSpecialStudent};
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/center/class/special',
                        {
                            id: classId as string,
                            studentId: x.id.toString(),
                            allow: '0',
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string | undefined,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'دانش‌آموز مورد نظر از لیست متمایزها حذف شد.',
                                'باشه',
                                5000,
                            );
                            ShowProgressLoading();
                            fetchData();
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
            <AdminsSpecialStudentPickerModal
                active={pickSpecialStudent}
                closeHandler={() => {
                    setPickSpecialStudent(false);
                    ShowProgressLoading();
                    fetchData();
                }}
                classId={classId as string}
                specialList={data.specialIds}
                onDone={() => {
                    fetchData();
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }}
            />
            <AdminsChooseStudentsForSciClassModal
                active={manuallyAddStudents}
                closeHandler={() => setManuallyAddStudents(false)}
                classId={classId as string}
                suggestedPrice={data.price}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }}
            />
            <ConfirmModal
                active={markAsPaid.show}
                closeHandler={() => setMarkAsPaid(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"ذخیره پرداخت دستی"}
                desc={`آیا مطمئن هستید که می‌خواهید هزینه این کلاس را برای ${markAsPaid.name} بصورت دستی به عنوان پرداخت شده ثبت کنید؟`}
                onOkay={() => {
                    const x = {...markAsPaid};
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/center/class/mark-paid',
                        {
                            record:x.recordId,
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'پرداخت ذخیره شد.',
                                'باشه',
                                5000,
                            );
                            ShowProgressLoading();
                            fetchData();
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
                icon={<ThinCreditScoreIcon/>}
            />
            <RemoveModal
                active={removeStudents.show}
                closeHandler={() => setRemoveStudents(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"حذف دانش‌آموز از کلاس"}
                desc={"آیا مطمئن هستید می‌خواهید " + removeStudents.name + " را از لیست دانش‌آموزان این کلاس حذف کنید؟"}
                onRemove={() => {
                    const x = {...removeStudents};
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/center/class/remove-student',
                        {
                            class: classId as string,
                            student: x.studentId.toString(),
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string | undefined,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'دانش‌آموز مورد نظر از لیست حذف شد.',
                                'باشه',
                                5000,
                            );
                            ShowProgressLoading();
                            fetchData();
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
        </>
    );
};